import React from "react";
import "../../App.css";

export default function Info() {
  return <h1 className="info">INFORMAÇÕES</h1>;
}
